import Component from './ExchangesPage';

export default Component;
